import React, {useState, useContext} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Pressable, Text, View } from 'react-native';
import { VENDORS_WITH_COUNT, HIDE_VENDOR } from './queries';
import { useMutation } from '@apollo/client';
import { Link } from 'app/src/utils/routing';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { abbreviations as states} from 'app/src/elements/states';
import Modal from '../../elements/Modal';
import NewVendor from './new';
import EditVendor from './edit';
import SubNav from '../../elements/SubNav';

import {
  VendorsContainer
} from './elements';
import {
  MainContainer,
  NavbarContainer,
  LinkContainer,
  LinkSpace,
  BoldLinkText
} from '../../elements';
import AuthContext from '../../contexts/AuthContext';

const inputStyle = {
  marginBottom: '10px'
}

const Vendors = () => {
  const { hasPolicy } = useContext(AuthContext);
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [clickedVendor, setClickedVendor] = useState();
  const [showAddVendorModal, setShowAddVendorModal] = useState(false);
  const [showEditVendorModal, setShowEditVendorModal] = useState(false);
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };
  const [hideVendor] = useMutation(
    HIDE_VENDOR, { onCompleted: refetch }
  )

  const onHide = (vendor) => {
    if(window.confirm(`Hide ${vendor.name}?`)) {
      hideVendor({ variables: { id: vendor.id }});
    }
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'name',
      label: 'Vendor Name',
      sort: 'asc',
      // width: '45%',
      content: (entry) => {
        return (
          // <View>
          //   <Link to={`/vendors/${entry.entry.id}`}>
          //     {entry.entry.name}
          //   </Link>
          // </View>
          entry.entry.name
        )
      }
    },
    {
      key: 'street',
      label: 'Address',
      // width: '20%',
      content: (entry) => {
        return entry.entry.street
      }
    },
    {
      key: 'city',
      label: 'City',
      // width: '20%',
      content: (entry) => {
        return entry.entry.city
      }
    },
    {
      key: 'state',
      label: 'State',
      // width: '20%',
      content: (entry) => {
        return entry.entry.state
      }
    },
    {
      key: 'zip',
      label: 'Zip',
      // width: '20%',
      content: (entry) => {
        return entry.entry.postalCode?.formatted
      }
    },
    {
      key: 'phoneNumber',
      label: 'Phone',
      // width: '20%',
      minViewportWidth: 1000,
      value: (entry) => entry.entry.phoneNumber?.formatted,
      content: (entry) => entry.entry.phoneNumber?.formatted
    },
    {
      key: 'email',
      label: 'Email',
      // width: '20%',
      minViewportWidth: 1000,
      value: (entry) => entry.entry.email,
      content: (entry) => entry.entry.email
    },
    {
      key: 'notes',
      label: 'Notes',
      content: (entry) => {
        return entry.entry.notes
      }
    },
    {
      key: 'taxClassification',
      label: 'Tax Classification',
      content: (entry) => {
        return entry.entry.taxClassification
      }
    },
    {
      key: 'llc',
      label: 'LLC?',
      content: (entry) => {
        return entry.entry.llc ? 'Yes' : 'No'
      }
    },
    {
      key: 'taxIdType',
      label: 'Tax ID Type',
      content: (entry) => {
        return entry.entry.taxIdType
      }
    },
    {
      key: 'taxIdNumber',
      label: 'Tax ID Number',
      content: (entry) => {
        return entry.entry.taxIdNumber
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      // width: '15%',
      // minViewportWidth: 1000,
      content: (entry) => {
        return (
          <LinkContainer>
            <Link to={`/vendors/${entry.entry.id}`}>
              <Text style={{textDecorationStyle: 'none'}}>
                View
              </Text>
            </Link>
            <LinkSpace/>
            <Pressable
              onPress={() => {
                setClickedVendor(entry.entry);
                setShowEditVendorModal(true);
              }}
            >
              <Text>Edit</Text>
            </Pressable>
            <LinkSpace/>
            {hasPolicy({ type: 'Vendor', action: 'hide' }) &&
              <Pressable
                onPress={() => onHide(entry.entry)}
              >
                Hide
              </Pressable>
            }
          </LinkContainer>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Vendor Name:</Text>
          <input
            type={'text'}
            name="name"
            onChange={e => setFilter('name', e.target.value)}
            value={filters.name || ''}
            style={inputStyle}
          />
          <Text>City:</Text>
          <input
            type={'text'}
            name="City"
            onChange={e => setFilter('city', e.target.value)}
            value={filters.city || ''}
            style={inputStyle}
          />
          <Text>State:</Text>
          <select
            type={'select'}
            name="state"
            onChange={e => setFilter('state', e.target.value)}
            value={filters.state || ''}
          >
            <option key={`state-all`}>
              {'All'}
            </option>
            {states.map(state =>
              <option key={`state-${state}`}>
                {state}
              </option>
            )}
          </select>
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <SubNav>{getSubNavContents()}</SubNav>
      <VendorsContainer>
        <DataTable.Gql
          setRefetch={setRefetch}
          query={VENDORS_WITH_COUNT}
          queryName='vendorsWithCount'
          columns={columns}
          buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.vendorsWithCount)}
          htmlTable
          queryVariables={queryVariables}
        />
        {showEditVendorModal &&
        <Modal
          refetch={refetch}
          showModal={showEditVendorModal}
          setShowModal={setShowEditVendorModal}
          modalType={'Edit Vendor'}
          objectName={clickedVendor.name}
        >
          <EditVendor
            setShowModal={setShowEditVendorModal}
            refetch={refetch}
            vendor={clickedVendor}
          />
        </Modal>
      }
      </VendorsContainer>
    </MainContainer>
  )

  function getSubNavContents() {
    return (
      <NavbarContainer>
        {getLinks()}
      </NavbarContainer>
    )

    function getLinks() {
      // if(location.pathname === '/vendors') {
        return (
          <View>
            <Pressable
              onPress={() => setShowAddVendorModal(true)}
            >
              <Text>+ Add Vendor</Text>
            </Pressable>
            {showAddVendorModal &&
              <Modal
                showModal={showAddVendorModal}
                setShowModal={setShowAddVendorModal}
                modalType={'Add Vendor'}
              >
                <NewVendor
                  setShowModal={setShowAddVendorModal}
                  refetch={refetch}
                />
              </Modal>
            }
          </View>
        )
      // }else if(location.pathname === '/vendors/new') {
      //   return (
      //     <Link to={`/vendors`}>
      //       <Text>Vendors</Text>
      //     </Link>
      //   )
      // }else {
      //   return (
      //     <LinkContainer>
      //       <BoldLinkText>{vendor.name}</BoldLinkText>
      //       <LinkSpace />
      //       <Pressable
      //         onPress={() => {
      //           setShowEditVendorModal(true)
      //         }}
      //       >
      //         <Text>
      //           Edit
      //         </Text>
      //       </Pressable>
      //       {showEditVendorModal &&
      //         <Modal
      //           refetch={refetch}
      //           showModal={showEditVendorModal}
      //           setShowModal={setShowEditVendorModal}
      //           modalType={'Edit Vendor'}
      //           objectName={vendor.name}
      //         >
      //           <EditVendor
      //             setShowModal={setShowEditVendorModal}
      //             refetch={refetch}
      //             vendorDetails={vendor}
      //           />
      //         </Modal>
      //       }
      //     </LinkContainer>
      //   )
      // }
    }
  }
}

export default Vendors;
